import React, { Component } from 'react'
import { auth } from '../../auth/auth'
import { Button, Header, Columns, Field } from 'components/elements'
import * as Yup from 'yup'
import { apiProcess } from '../../api/api.js'
import AppContainer from '../../context/AppContainer'
import { Subscribe } from 'unstated'
import { trackUserLogIn } from '../../elements/klaviyoTracking/userLogIn'
import {
  trackViewSendResetPasswordScreen,
  trackResetPasswordResetEmailAttempt,
  trackResetPasswordEmailSent,
  trackLogInAttempt,
  trackLogInAndSetInfo,
} from '../../elements/tracking/loginTracking'
import PasswordInput from '../passwords/passwordInput'
import { withRouter } from 'react-router-dom'

const loginFormSchema = Yup.object().shape({
  username: Yup.string('Email is required.')
    .email('This must be an email address.')
    .required('Email is required.'),
  password: Yup.string('Password is required.').required(
    'Password is required.'
  ),
})

const forgotPasswordScehma = Yup.object().shape({
  username: Yup.string('Email is required.')
    .email('This must be an email address.')
    .required('Email is required.'),
})

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      loading: false,
      errors: {
        username: false,
        password: false,
      },
      oldUser: false,
      forgotPassword: false,
      forgotPasswordSent: false,
      passwordIcon: 'eye',
      passwordFieldType: 'password',
    }
  }

  componentDidMount() {
    if (this.props.container === 'page') {
      if (this.props.pageType === '/reset-password') {
        this.setState({ forgotPassword: true })
      }
    }
  }

  checkLoginFields = (event, updateAuthState) => {
    event.preventDefault()

    this.setState({
      loading: true,
    })

    loginFormSchema
      .validate(
        {
          username: this.state.username,
          password: this.state.password,
        },
        { abortEarly: false }
      )
      .then(
        function(valid) {
          this.doLogin(updateAuthState)
        }.bind(this)
      )
      .catch(
        function(responseData) {
          //console.log(responseData)
          for (let i = 0; i < responseData.inner.length; i++) {
            this.setState((state) => {
              state.errors[responseData.inner[i]['path']] =
                responseData.inner[i]['message']
              return state
            })
          }

          this.setState({
            loading: false,
          })

          trackLogInAttempt({
            error_message: responseData.inner,
            error_code: 'n/a',
            error_type: 'user',
          })
        }.bind(this)
      )
  }

  doLogin = (updateAuthState) => {
    let username = this.state.username
    let password = this.state.password
    //        let loginResults = auth.login(username, password)
    auth
      .login(username, password)
      .then(
        function(responseData) {
          //if there is redirect then do it here.
          //if not, then just close the modal.
          //close the modal.
          //callbacks here:

          trackLogInAndSetInfo(responseData, this.props.parentDescription)
          trackUserLogIn(this.state.username)
          updateAuthState()
          setTimeout(() => this.props.onSuccess(), 1500)
        }.bind(this)
      )

      .catch(
        function(responseData) {
          //console.log('something wrong', responseData)
          let errorCode = responseData.errorCode
          let errorMessage = ''
          //custom error handling for the login page.
          if (
            errorCode === '401' ||
            errorCode === 401 ||
            errorCode === '404' ||
            errorCode === 404
          ) {
            //console.log(errorCode)
            errorMessage = 'The email or password is incorrect.'
            this.setState((state) => {
              state.errors['username'] = errorMessage
              state.loading = false
              return state
            })
          } else if (errorCode === '409' || errorCode === 409) {
            this.setState((state) => {
              state.oldUser = true
              state.loading = false
              return state
            })
            errorMessage =
              'We have a new website! You need to reset your password.'
          } else if (errorCode === '429' || errorCode === 429) {
            errorMessage =
              'Too many login attempts. Your account has been locked for 1 hour.'
            this.setState((state) => {
              state.errors['username'] = errorMessage
              state.loading = false
              return state
            })
          } else {
            errorMessage = 'Something went wrong. Please try again.'
            this.setState((state) => {
              state.errors['username'] = errorMessage
              state.loading = false
              return state
            })
          }

          trackLogInAttempt({
            error_message: errorMessage,
            error_code: errorCode,
            error_type: 'server',
          })
        }.bind(this)
      )
  }

  showLogin = () => {
    this.setState({
      oldUser: false,
      forgotPassword: false,
      username: '',
      password: '',
      forgotPasswordSent: false,
    })
  }

  showResetPasswordScreen = () => {
    trackViewSendResetPasswordScreen(this.props.container)
    this.setState({
      forgotPassword: true,
      errors: {
        username: false,
        password: false,
      },
    })
  }

  resetPasswordValidate = () => {
    this.setState({
      loading: true,
    })

    forgotPasswordScehma
      .validate(
        {
          username: this.state.username,
        },
        { abortEarly: false }
      )
      .then(
        function(valid) {
          this.doResetPassword()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          for (let i = 0; i < responseData.inner.length; i++) {
            this.setState((state) => {
              state.errors[responseData.inner[i]['path']] =
                responseData.inner[i]['message']
              return state
            })
          }
          this.setState({
            loading: false,
          })
          trackResetPasswordResetEmailAttempt({
            page_type: this.props.container,
            error_messsage: 'User Field Validation Error',
            error_code: 'na',
            error_type: 'user',
          })
        }.bind(this)
      )
  }

  doResetPassword = () => {
    let apiURL = 'users/request_password_reset'

    let resetData = {
      email: this.state.username,
    }

    apiProcess(
      apiURL,
      resetData,
      'request-password-reset',
      'Login - Forget Password Component'
    )
      .then(
        function(responseData) {
          this.setState((state) => {
            state.errors['username'] = false
            state.loading = false
            state.forgotPasswordSent = true
            return state
          })
          trackResetPasswordEmailSent(this.props.container)
          this.props.onPasswordReset()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState((state) => {
            state.errors['username'] = 'We are having issues. Please try again.'
            state.loading = false
            return state
          })
          trackResetPasswordResetEmailAttempt({
            page_type: this.props.container,
            error_messsage: 'We are having issues. Please try again.',
            error_code: responseData.errorCode,
            error_type: 'server',
          })
        }.bind(this)
      )
  }

  defaultLoginHandle = () => {}

  toggleShowPassword = () => {
    if (this.state.passwordIcon === 'eye') {
      this.setState({
        passwordIcon: 'eye slash outline',
        passwordFieldType: 'text',
      })
    } else {
      this.setState({
        passwordIcon: 'eye',
        passwordFieldType: 'password',
      })
    }
  }

  render() {
    const {
      username,
      errors,
      loading,
      oldUser,
      forgotPassword,
      forgotPasswordSent,
    } = this.state

    const { hideShowLoginButtonEmailSent, hideShadow } = this.props

    return (
      <Subscribe to={[AppContainer]}>
        {(auth) => {
          return (
            <div className={hideShadow ? 'no-box' : 'box'}>
              {!forgotPassword && !oldUser && (
                <form onSubmit={(e) => this.checkLoginFields(e, auth.logIn)}>
                  <Columns>
                    <Columns.Column size={12}>
                      <Header
                        renderas={'h1'}
                        className="has-text-centered"
                        style={{
                          marginBottom: '1.5rem !important',
                          fontWeight: '800',
                        }}
                      >
                        WELCOME BACK
                      </Header>
                      <Field
                        iconLeft={'fal fa-user'}
                        name="username"
                        id="username"
                        placeholder="Email Address"
                        fullwidth
                        showErrors={false}
                        autocomplete="false"
                        error={errors.username}
                        onChange={({ value }) =>
                          this.setState((state) => {
                            state.errors['username'] = false
                            state.username = value.trim()
                            return state
                          })
                        }
                        size="medium"
                        value={username}
                        type="input"
                      />
                      {errors.username && (
                        <div
                          className="is-size-7 has-text-danger"
                          style={{ marginTop: '-.5rem' }}
                        >
                          {errors.username}
                        </div>
                      )}
                      <PasswordInput
                        onChange={(hint, value) =>
                          this.setState((state) => {
                            state.errors['password'] = false
                            state.password = value
                            return state
                          })
                        }
                        size="medium"
                        showHints={false}
                        showBar={false}
                        error={errors.password}
                        //label="Current Password"
                        placeholder={'Password'}
                      />
                      <div className="columns">
                        <div className="column is-6">
                          {errors.password && (
                            <div className="is-size-7 has-text-danger mt-1">
                              {errors.password}
                            </div>
                          )}
                        </div>
                        <div className="column is-6 has-text-right">
                          <button
                            href="#"
                            type="button"
                            className="is-size-7 pt-2 button is-white has-text-primary"
                            onClick={() => this.showResetPasswordScreen()}
                          >
                            Reset Password
                          </button>
                        </div>
                      </div>

                      <Button
                        color="primary"
                        loading={loading}
                        disabled={loading}
                        size="medium"
                        fullwidth
                        className="mt-4 has-text-weight-extra-bold"
                        onClick={(e) => this.checkLoginFields(e, auth.logIn)}
                      >
                        Login
                      </Button>

                      {this.props.showBottomLinks && (
                        <div className="has-text-centered">
                          <br />
                          <p>No Twisted Road Account?</p>
                          <a href="/register">Sign Up Now</a>
                        </div>
                      )}
                    </Columns.Column>
                  </Columns>
                </form>
              )}
              {oldUser && (
                <Columns>
                  <Columns.Column className="has-text-centered">
                    <h3 className="header has-text-weight-extra-bold">
                      We've recently updated our website.
                    </h3>
                    <p className="mb-4">
                      To ensure your security, we've sent an email to
                      <br />
                      <strong>{username}</strong> to reset your password.
                      <br />
                      Make sure to check your spam and junk folder!
                    </p>
                    <Button
                      color="primary"
                      fullwidth
                      size="medium"
                      className="has-text-extra-bold"
                      onClick={() => this.showLogin()}
                    >
                      Back To Login
                    </Button>
                  </Columns.Column>
                </Columns>
              )}
              {forgotPassword && !forgotPasswordSent && (
                <React.Fragment>
                  <Columns>
                    <Columns.Column size={12}>
                      <Header
                        renderas="h1"
                        size={5}
                        className="has-text-centered has-text-weight-bold"
                      >
                        Enter your email address to reset your password.
                      </Header>
                      <Field
                        id="username"
                        iconLeft="fal fa-user"
                        name="username"
                        placeholder="Email Address"
                        fullwidth
                        error={errors.username}
                        onChange={({ value }) =>
                          this.setState((state) => {
                            state.errors['username'] = false
                            state.username = value
                            return state
                          })
                        }
                        size="medium"
                        showErrors={false}
                        value={username}
                        type="input"
                      />
                      {errors.username && (
                        <div className="is-size-7 has-text-danger">
                          {errors.username}
                        </div>
                      )}
                    </Columns.Column>
                  </Columns>
                  <Columns>
                    <Columns.Column size={12}>
                      <Button
                        color="primary"
                        loading={loading}
                        size="medium"
                        disabled={loading}
                        fullwidth="true"
                        className="has-text-weight-extra-bold"
                        onClick={() => this.resetPasswordValidate()}
                      >
                        Send Password Reset
                      </Button>
                    </Columns.Column>
                  </Columns>
                </React.Fragment>
              )}
              {forgotPassword && forgotPasswordSent && (
                <Columns>
                  <Columns.Column className="content">
                    <Header
                      renderas="h1"
                      size={3}
                      className="has-text-centered has-text-weight-extra-bold"
                    >
                      Email Sent
                    </Header>
                    <p className="has-text-centered mt-4">
                      An Email has been sent to the email on file for your
                      account.
                      <br />
                      Please follow the link to reset your password.
                      <br />
                      <strong>
                        Make sure to check your spam and junk folder!
                      </strong>
                    </p>
                    {!hideShowLoginButtonEmailSent && (
                      <Button
                        color="primary"
                        fullwidth
                        size="medium"
                        className={'has-text-weight-extra-bold'}
                        onClick={() => this.showLogin()}
                      >
                        Back To Login
                      </Button>
                    )}
                  </Columns.Column>
                </Columns>
              )}
            </div>
          )
        }}
      </Subscribe>
    )
  }
}

export default withRouter(LoginForm)

LoginForm.defaultProps = {
  onSuccess: function() {},
  onPasswordReset: function() {},
  pageType: null,
  container: 'modal',
  showBottomLinks: false,
  parentDescription: 'Missing Parent Description',
}
